export default __webpack_public_path__ + "static/media/miguel-lopes-42.b0f434d6.jpg";